export const OKTA_SESSION_TIMEOUT = 7.5 * 60 * 60 * 1000; // 7 hours 30 minutes
export const COUNTDOWN_DURATION = 30 * 60; // 30 minutes
export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || '';
export const LOG_OUT_URL = process.env.REACT_APP_LOGOUT_URI || '';
export const WALK_ME_URL = process.env.REACT_APP_WALKME_URL || '';
